const KEY = 'mmo.ui_state';

interface UiState {
  equipDividerWidth?: number;
  skillsScrollTop?: number;
}

function load(): UiState {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as UiState) : {};
  } catch {
    return {};
  }
}

function save(patch: Partial<UiState>): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...load(), ...patch }));
  } catch {
    // localStorage unavailable — silently ignore
  }
}

export function getEquipDividerWidth(defaultWidth: number): number {
  return load().equipDividerWidth ?? defaultWidth;
}

export function saveEquipDividerWidth(width: number): void {
  save({ equipDividerWidth: width });
}

export function getSkillsScrollTop(): number {
  return load().skillsScrollTop ?? 0;
}

export function saveSkillsScrollTop(top: number): void {
  save({ skillsScrollTop: top });
}
